import {
  COMMUNITY_PATH,
  DOCUMENTATION_PATH,
  MY_FILES_PATH,
  PROFILE_PATH,
  SUPPORT_PATH,
} from '../constants/routes';

import { CabinetConfig, SettingsMenuItem } from '../types/menu';

export default (_config: CabinetConfig, _displaySize: string) => {
  const menuItems: Record<string, SettingsMenuItem> = {
    files: {
      url: MY_FILES_PATH,
      activePath: MY_FILES_PATH,
      label: 'files.nav.files',
      name: 'files',
      icon: 'menu-myFiles',
    },
    profile: {
      url: PROFILE_PATH,
      activePath: PROFILE_PATH,
      label: 'files.nav.profile',
      name: 'profile',
      icon: 'menu-profile',
    },
    community: {
      url: COMMUNITY_PATH,
      activePath: COMMUNITY_PATH,
      label: 'files.nav.community',
      name: 'community',
      icon: 'menu-community',
    },
    support: {
      url: SUPPORT_PATH,
      activePath: SUPPORT_PATH,
      label: 'files.nav.support',
      name: 'support',
      icon: 'menu-support',
    },
    documentation: {
      url: DOCUMENTATION_PATH,
      activePath: DOCUMENTATION_PATH,
      label: 'files.nav.documentation',
      name: 'documentation',
      icon: 'menu-documentation',
    },
  };

  return menuItems;
};
